module.exports = __webpack_public_path__ + "static/media/heroimage_igib-011.25e66f46.jpg";